import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './store';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(i18n);

// Wait for the initial route's async component chunk to resolve before
// mounting, so the static #app-loader (see public/index.html) stays visible
// for the whole load instead of Vue mounting to a blank <router-view>
// while that chunk is still being fetched.
router.isReady().then(() => {
  app.mount('#app');
});
